import { C4ListResponse } from '@domain/interface/c4-list-response';
import { createAction, props } from '@ngrx/store';
import { BulkCapacityMatchJob, Owner } from 'cargo-chief-commons';

export const AUTOMATION_LOADS = {
	LOADS_LIST: {
		GET: createAction('[Automation Loads] Get loads', props<any>()),
		SUCCESS: createAction('[Automation Loads] Get loads success', props<C4ListResponse<any>>()),
		FAILURE: createAction(
			'[Automation Loads] Get loads failure',
			props<{ payload: { message: string } }>()
		),
	},

	SORT: {
		SET: createAction('[SORT] Loads Automation Set sort', props<{ sort: any[] }>()),
	},

	FILTERS: {
		SET: createAction('[FILTERS] Loads Automation Set filters', props<{ filters: any[] }>()),
	},

	ACTIVE_TAB: {
		SET: createAction(
			'[ACTIVE_TAB] Automation loads Set ACTIVE_TAB',
			props<{ activeTab: string }>()
		),
	},

	IMPORT_LOADS_UPLOAD_FILE: {
		OPEN_DIALOG: createAction('[Automation Loads] open import loads dialog', props<any>()),
		CLOSE_DIALOG: createAction('[Automation Loads] close import loads dialog', props<any>()),
		UPLOAD: createAction('[Automation Loads] import loads', props<any>()),
		SUCCESS: createAction('[Automation Loads] import loads success', props<any>()),
		FAILURE: createAction(
			'[Automation Loads] import loads failure',
			props<{ payload: { message: string } }>()
		),
	},

	CARRIER_OFFER_STATUS: {
		OPEN_DIALOG: createAction(
			'[Automation Loads] open carrier status update confirmation dialog',
			props<any>()
		),
		CLOSE_DIALOG: createAction(
			'[Automation Loads] close carrier status update confirmation dialog',
			props<any>()
		),
		UPDATE: createAction('[Automation Loads] carrier status update', props<any>()),
		SUCCESS: createAction('[Automation Loads] carrier status update success', props<any>()),
		FAILURE: createAction(
			'[Automation Loads] carrier status update failure',
			props<{ payload: { message: string } }>()
		),
		SET_CARRIERS_OFFER_STATUS: createAction(
			'[Automation Loads] set carrier offer status',
			props<any>()
		),
		SET_BA_ACCOUNT_SETTING_DISABLED: createAction(
			'[Automation Loads] ba account setting disabled',
			props<any>()
		),
	},

	USERS_LIST: {
		SET: createAction(
			'[UsersList] Set Users List for loads automation',
			props<{ usersList: Owner[] }>()
		),
	},

	REPROCESS_FILES: {
		UPDATE: createAction('[Automation Loads] reprocess loads file', props<any>()),
		SUCCESS: createAction('[Automation Loads] reprocess loads file success', props<any>()),
		FAILURE: createAction(
			'[Automation Loads] reprocess loads file failure',
			props<{ payload: { message: string } }>()
		),
	},

	IMPORT_JOB: {
		ADD: createAction(
			'[Automation Loads] Import job added',
			props<{ bulkCapacityMatchJob: BulkCapacityMatchJob }>()
		),
		UPDATE: createAction(
			'[Automation Loads] Import job updated',
			props<{ bulkCapacityMatchJob: BulkCapacityMatchJob }>()
		),
	},
};
